import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { commonService } from "../../Network/services/commonService";
import { profileUpdateService } from "../../Network/services/profileUpdateService";
import { useLocation, useHistory } from "react-router-dom";
import { Link,useNavigate } from "react-router-dom";
import { googleLogout } from '@react-oauth/google';
import StorageHelper from "../../utils/storageHelper";

import Files from "react-files";

import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import Modal from "react-modal";
import ReactPasswordToggleIcon from 'react-password-toggle-icon';

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/deleteProfile.css";
import "./MyResumeEditView.css";
import WarningIcon from "../../assets/images/warning_icon.png";
import Select from "react-dropdown-select";
import FilePreview from "../FilePreview";
import { Rating } from 'react-simple-star-rating';

const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const MyProfileView = (props) => {
  
  const oldPassword1 = useRef(null);
  const newPassword1 = useRef(null);
  const confirmNewPassword = useRef(null);

  const showIcon = () => <i className="fa fa-eye" aria-hidden="true"></i>;
  const hideIcon = () => <i className="fa fa-eye-slash" aria-hidden="true"></i>


  let location = useLocation();
  let history = useHistory();

  const [profile, setProfile] = useState({});
  const [name, setName] = useState("");
  const [rating, setRating] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [emailEdit, setEmailEdit] = useState("");
  const [phoneEdit, setPhoneEdit] = useState("");
  const [mailOTP, setMailOTP] = useState("");
  const [phoneOTP, setPhoneOTP] = useState("");
  const [connectCount, setConnectCount] = useState(0);
  const [isEmail, setIsEmail] = useState(false);
  const [fetchprofile, setFetchprofile] = useState(true);

  const [total, setTotal] = useState(0);
  const [project_rate, setproject_rate] = useState("");
  const [project_rate_type, setproject_rate_type] = useState("");
  const [image, setImage] = useState("");
  const [skills, setSkills] = useState([]);
  const [projects_completed, setprojects_completed] = useState([]);
  const [total_inprogress_project, settotal_inprogress_project] = useState([]);

  const [personalname, setPersonalname] = useState([]);
  const [personalprofession, setPersonalprofession] = useState([]);
  const [professionalName, setProfessionalName] = useState([]);
  const [professionalprofession, setProfessionalprofession] = useState([]);
  const [isMobileVerified, setIsMobileVerified] = useState("");
  const [isEmailVerified, SetIsEmailVerified] = useState("");
  const [loginType, SetLoginType] = useState("");
  const [profilePercentage, SetProfilePercentage] = useState(0);

  const [iskycFilled, setIsKycFilled] = useState("");
  const [webLink, setWebLink] = useState("");

  const [certlist, setCertlist] = useState();
  const [resumelist, setResumelist] = useState();
  const [isLoadingFiles, setIsLoadingFiles] = useState(true);

  const [loading, setLoading] = useState(false);

  const [isChangePasswordModelOpen, setIsChangePasswordModelOpen] = useState(false);  
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordErrors, setPasswordErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [remainingMinutes, setRemainingMinutes] = useState(null);

  const [isEmailMobileModelOpen, setIsEmailMobileModelOpen] = useState(false);

  const [mobileEmailEditTitle, setMobileEmailEditTitle] = useState("Edit Mobile Number");
  
  const [updateEmail, setUpdateEmail] = useState("");
  const [updateMobile, setUpdateMobile] = useState("");
  const [showMobileField, setShowMobileField] = useState(false);
  const [showEmailField, setShowEmailField] = useState(false);
  const [showMobileOTPField, setShowMobileOTPField] = useState(false);
  const [mobileOTP, setMobileOTP] = useState("");
  const [showEmailOTPField, setShowEmailOTPField] = useState(false);
  const [emailOTP, setEmailOTP] = useState("");

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [deleteType, setDeleteType] = useState("");
  const [deleteAnimation, setDeleteAnimation] = useState(false);
  
  const [isLogoutConfirmationModalOpen, setIsLogoutConfirmationModalOpen] = useState(false);
  const [logoutAnimation, setLogoutAnimation] = useState(false);
  const [remainingEmailMinutes, setRemainingEmailMinutes] = useState(null);
  const [remainingCooldownSeconds, setRemainingCooldownSeconds] = useState(null);
  const [remainingEmailCooldownSeconds, setRemainingEmailCooldownSeconds] = useState(null);
  
  const [isKycVerificationModalOpen, setIsKycVerificationModalOpen] = useState(false);
  const [kycVerificationMessage, setKycVerificationMessage] = useState("");

  const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);
  const [fetchedRating, setFetchedRating] = useState(0);
  const [ratingList, setRatingList] = useState([]);

  let apiCallInProgress = false;
let apiCallLock = {};

const getAttemptsKey = (mobile) => `otp_attempts_${mobile}`;
const getBlockKey = (mobile) => `otp_block_${mobile}`;
const getLockKey = (mobile) => `otp_lock_${mobile}`;
const getCooldownKey = (mobile) => `otp_cooldown_${mobile}`; 

const getEmailAttemptsKey = (email) => `otp_email_attempts_${email}`;
const getEmailBlockKey = (email) => `otp_email_block_${email}`;
const getEmailLockKey = (email) => `otp_email_lock_${email}`;
const getEmailCooldownKey = (email) => `otp_email_cooldown_${email}`; 
  
  useEffect(() => {
    let user = JSON.parse(window.localStorage.getItem("UserData"));
    SetLoginType(user.login_type);
  }, []);

useEffect(() => {
  if (!updateEmail) {
    setRemainingEmailMinutes(null);
    setRemainingEmailCooldownSeconds(null);
    return;
  }
  
  const checkTime = () => {
    const minutes = getEmailRemainingTime(updateEmail);
    setRemainingEmailMinutes(minutes);
    
    const cooldownSeconds = getEmailCooldownRemainingTime(updateEmail);
    setRemainingEmailCooldownSeconds(cooldownSeconds);
  };
  
  checkTime();
  
  const interval = setInterval(() => {
    checkTime();
  }, 1000);
  
  return () => clearInterval(interval);
}, [updateEmail]);

  
useEffect(() => {  
   if (!updateMobile) {
    setRemainingMinutes(null);
    setRemainingCooldownSeconds(null);
    return;
  }
  
  const checkTime = () => {
    const minutes = getRemainingTime(updateMobile);
    setRemainingMinutes(minutes);
    
    const cooldownSeconds = getCooldownRemainingTime(updateMobile);
    setRemainingCooldownSeconds(cooldownSeconds);
  };
  
  checkTime();
  
  const interval = setInterval(() => {
    checkTime();
  }, 1000);
  
  return () => clearInterval(interval);
  }, [updateMobile]);

  const calculateAverageRating = (ratingList) => {
    if (!ratingList || !Array.isArray(ratingList) || ratingList.length === 0) {
      return 0;
    }
    
    const sum = ratingList.reduce((total, item) => {
      const ratingValue = parseFloat(item.user_rating || 0);
      return total + ratingValue;
    }, 0);
    
    const average = sum / ratingList.length;
    return parseFloat(average.toFixed(1));
  };

  const fetchAndUpdateProfileRating = async () => {
    try {
      let user = JSON.parse(window.localStorage.getItem("UserData"));
      const userId = user.id;

      const form = new FormData();
      form.append("user_id", userId);

      const response = await commonService.CommonService("get_user_rating", form);
      
      if (response.status === "200" || response.status === 200) {
        let ratingDataList = [];
        if (response.data && Array.isArray(response.data)) {
          ratingDataList = response.data;
        }
        const calculatedRating = calculateAverageRating(ratingDataList);
        setRating(calculatedRating);
      }
    } catch (error) {
      console.error("Error fetching user rating:", error);
    }
  };

  useEffect(() => {
   
    let guser = JSON.parse(window.localStorage.getItem("UserData"));
    const getUserDetail = new FormData();
    getUserDetail.append( "user_id", guser.id );
    let user = [];
    profileUpdateService
    .profile(getUserDetail)
    .then(async (res) => {
      if (res.status == 200) {
        user = res.data[0];
        window.localStorage.setItem("UserData", JSON.stringify(user));



        if (user.profile_image && user.profile_image.trim() !== "") {
          if(user.profile_image.includes("https://")){
            setImage(user.profile_image);
          } else {
            setImage(`${process.env.REACT_APP_BACKEND_BASE_URL}/` + user.profile_image);
          }
        } else {
          setImage(null);
        }

        setProfile(user);

        setName(user.first_name + " " + user.last_name);
        let personal_preference_name1_array = user.personal_preference_name2.split(
          ","
        );
        setPersonalname(personal_preference_name1_array);
        let personal_preference_profession1_array = user.personal_preference_profession2.split(
          ","
        );
        setPersonalprofession(personal_preference_profession1_array);
        let personal_preference_name2_array = user.personal_preference_name1.split(
          ","
        );
        setProfessionalName(personal_preference_name2_array);
        let personal_preference_profession2_array = user.personal_preference_profession1.split(
          ","
        );
        setProfessionalprofession(personal_preference_profession2_array);
        setproject_rate(user.project_rate);
        setproject_rate_type(user.project_rate_type);
        setprojects_completed(user.total_completed_project);
        settotal_inprogress_project(user.total_inprogress_project);
        setEmail(user.email_id);
        setPhone(user.mobile_number);
        fetchAndUpdateProfileRating();
        setIsMobileVerified(user.verify_mobile);
        SetIsEmailVerified(user.verify_email);
        setSkills(user.skills ? user.skills.split(",") : []);
        SetLoginType(user.login_type);
        setIsKycFilled(user.is_kyc_updated);
        setWebLink(user.web_link);
        setConnectCount(user.total_connects);
        
        SetProfilePercentage(user.profile_percentage);
        let total_experience_array = user.total_experience ? user.total_experience.split(",") : [];
        let sum = total_experience_array.reduce(function(prev, current) {
          const numericValue = parseFloat(current.trim()) || 0;
          return prev + numericValue;
        }, 0);
        setTotal(sum);

        let resumeFile = "";

        
        if(user.resume !== "" && user.resume){
          let resumeFilename = user.resume.split('/').pop();
          resumeFile = (
            <FilePreview 
              fileUrl={user.resume}
              fileName={resumeFilename}
              onRemove={null}
            />
          );
        }
        setResumelist(resumeFile);

        let certificates = "";
        let existingCerts = [];
        if(user.certificates !== "" && user.certificates){
          existingCerts = user.certificates.split(',');
          certificates = existingCerts.map((item, index) => {
            let filename = item.split('/').pop();
            return (
              <FilePreview 
                key={index}
                fileUrl={item}
                fileName={filename}
                onRemove={() => handleCertificateRemove(item)}
              />
            );
          });
        }
        setCertlist(certificates);

      } else {
        
      }
    })
    .catch((err) => {
      toast.success("Something went wrong! please try again later!!", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    })
    .finally(() => {
      setIsLoadingFiles(false);
    });

    if(iskycFilled==3){
      
      let keyToken = window.localStorage.getItem("kyctoken");
      
      const checkKycStatusForm = new FormData();  
      checkKycStatusForm.append('reference_id', keyToken);

      profileUpdateService
      .verifyKycStatus(checkKycStatusForm)
      .then(async (res) => {
        if (res.status == 200) {
             
          setIsKycFilled(1);
         

                  
        
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });

    }
     

  }, [iskycFilled]);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };



const isEmailAPICallInProgress = (email) => {
  const lockKey = getEmailLockKey(email);
  const lockData = sessionStorage.getItem(lockKey);
  
  if (!lockData) return false;
  
  const lockTime = parseInt(lockData, 10);
  const currentTime = Date.now();
  const fiveSeconds = 5000;
  
  if (currentTime - lockTime < fiveSeconds) {
    return true;
  } else {
    sessionStorage.removeItem(lockKey);
    return false;
  }
};

const setEmailAPICallLock = (email) => {
  const lockKey = getEmailLockKey(email);
  sessionStorage.setItem(lockKey, Date.now().toString());
};

const removeEmailAPICallLock = (email) => {
  const lockKey = getEmailLockKey(email);
  sessionStorage.removeItem(lockKey);
};

const isEmailBlocked = (email) => {
  const blockKey = getEmailBlockKey(email);
  const blockData = localStorage.getItem(blockKey);
  
  if (!blockData) return false;
  
  try {
    const blockInfo = JSON.parse(blockData);
    const blockTime = blockInfo.timestamp;
    const currentTime = Date.now();
    const timeElapsed = currentTime - blockTime;
    const fiveMinutes = 30 * 60 * 1000;  
    
    if (timeElapsed < fiveMinutes) {
      return true;
    } else {
      localStorage.removeItem(blockKey);
      localStorage.removeItem(getEmailAttemptsKey(email));
      sessionStorage.removeItem(getEmailLockKey(email));
      return false;
    }
  } catch (error) {
    return false;
  }
};

const getEmailAttemptsCount = (email) => {
  const attemptsKey = getEmailAttemptsKey(email);
  const attemptsData = localStorage.getItem(attemptsKey);
  const count = attemptsData ? parseInt(attemptsData, 10) : 0;
  return count;
};

const setEmailAttemptsCount = (email, count) => {
  const attemptsKey = getEmailAttemptsKey(email);
  localStorage.setItem(attemptsKey, count.toString());
};

const blockEmailUser = (email) => {
  const blockKey = getEmailBlockKey(email);
  const blockData = {
    timestamp: Date.now(),
    email: email
  };
  localStorage.setItem(blockKey, JSON.stringify(blockData));
  const cooldownKey = getEmailCooldownKey(email);
  sessionStorage.removeItem(cooldownKey);
};

const getEmailRemainingTime = (email) => {
  const blockKey = getEmailBlockKey(email);
  const blockData = localStorage.getItem(blockKey);
  if (!blockData) return null;

  try {
    const blockInfo = JSON.parse(blockData);
    const blockTime = blockInfo.timestamp;
    const currentTime = Date.now();
    const timeElapsed = currentTime - blockTime;
    const fiveMinutes = 30 * 60 * 1000; 
    const remainingTime = fiveMinutes - timeElapsed;

    if (remainingTime > 0) {
      const remainingMinutes = Math.ceil(remainingTime / (60 * 1000));
      return remainingMinutes;
    }
  } catch (error) {
    console.error('[DEBUG] Error calculating email remaining time:', error);
  }

  return null;
};

const isEmailOTPButtonDisabled = (emailArg) => {
  const targetEmail = (emailArg ?? updateEmail ?? '').toString().trim();
  if (!targetEmail) return false;
  return isEmailBlocked(targetEmail) || isEmailOnCooldown(targetEmail);
};

  const redirect = () => {
    history.push("/ExperienceUpdate");
  };

  const handleCertificateRemove = (certificateUrl) => {
    setLoading(true);
    
    const form = new FormData();   
    form.append('certificate', certificateUrl);

    profileUpdateService
      .removeCertificate(form)
      .then(async (res) => {
        if (res.status == 200) {
          window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
          window.localStorage.setItem("auth_token", res.data[0].auth_token);
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          window.location.reload(false);
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //update profile
  const updateProfile = (e) => {
    e.preventDefault();
    setLoading(true);

    const FormData = require("form-data");

    const form = new FormData();

    profileUpdateService
      .profileUpdatecall(form)
      .then(async (res) => {
        if (res.status == 200) {
          window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
          window.localStorage.setItem("auth_token", res.data[0].auth_token);
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //change password
  const changePassword = (e) => {
    e.preventDefault();
    
    // Validate all fields
    const errors = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    };
    
    let hasErrors = false;
    
    if(!oldPassword || oldPassword.trim() === ""){
      errors.oldPassword = "Old Password is required";
      hasErrors = true;
    }

    if(!newPassword || newPassword.trim() === ""){
      errors.newPassword = "New Password is required";
      hasErrors = true;
    } else {
      const hasMinLength = newPassword.length >= 8;
      const hasUpperCase = /[A-Z]/.test(newPassword);
      const hasNumber = /[0-9]/.test(newPassword);
      const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(newPassword);

      if(!hasMinLength){
        errors.newPassword = 'Password must be at least 8 characters';
        hasErrors = true;
      } else if(!hasUpperCase){
        errors.newPassword = 'Password must contain at least 1 uppercase letter';
        hasErrors = true;
      } else if(!hasNumber){
        errors.newPassword = 'Password must contain at least 1 number';
        hasErrors = true;
      } else if(!hasSpecialChar){
        errors.newPassword = 'Password must contain at least 1 special character';
        hasErrors = true;
      }
    }

    if(!confirmPassword || confirmPassword.trim() === ""){
      errors.confirmPassword = "Confirm Password is required";
      hasErrors = true;
    } else if(newPassword !== confirmPassword){
      errors.confirmPassword = 'Passwords do not match';
      hasErrors = true;
    }
    
    setPasswordErrors(errors);
    
    if(hasErrors){
      toast.error("Please fix the errors before submitting", {
        position: "top-right",
        type: "error",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    setLoading(true);
    
    // change password
    const change_password_form = new FormData();
    change_password_form.append('old_password', oldPassword);
    change_password_form.append('new_password', newPassword);
    change_password_form.append('confrm_password', confirmPassword);
    profileUpdateService
    .changepasswordCall(change_password_form)
    .then(async (res) => {
      if (res.status == 200) {
        toast.success(res.message, {
          position: "top-right",
          type: "success",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });

        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setPasswordErrors({
          oldPassword: "",
          newPassword: "",
          confirmPassword: ""
        });
        setIsChangePasswordModelOpen(false);
      } else {
        toast.error(res.message || "Failed to change password", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      }
    })
    .catch((err) => {
      toast.error("Something went wrong! please try again later!!", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    })
    .finally(() => {
      setLoading(false);
    });
  }

  //email update
const emailSubmit = (e) => {
  e.preventDefault();
  
  const currentEmail = (email || '').toString().trim();
  const newEmail = (updateEmail || '').toString().trim();
  if (newEmail && currentEmail && newEmail.toLowerCase() === currentEmail.toLowerCase()) {
    setLoading(false);
    toast.error("New email is same as current email", {
      position: "top-right",
      type: "error",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
    });
    return;
  }

  if (!newEmail || newEmail.length === 0) {
    setLoading(false);
    toast.error("Please enter valid Email", {
      position: "top-right",
      type: "error",
      autoClose: 5000,
    });
    return;
  }

  if (isEmailAPICallInProgress(newEmail)) {
    toast.warning("Please wait, request is being processed...", {
      position: "top-right",
      autoClose: 2000,
    });
    return;
  }

  if (!isEmailBlocked(newEmail) && isEmailOnCooldown(newEmail)) {
    const remainingSeconds = getEmailCooldownRemainingTime(newEmail);
    toast.warning(`Please wait ${remainingSeconds} seconds before requesting OTP again`, {
      position: "top-right",
      autoClose: 3000,
    });
    return;
  }

  if (isEmailBlocked(newEmail)) {
    const remainingMinutes = getEmailRemainingTime(newEmail);
    toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }

  const currentAttempts = getEmailAttemptsCount(newEmail);

  if (currentAttempts >= 3) {
    blockEmailUser(newEmail);
    const remainingMinutes = getEmailRemainingTime(newEmail);
    toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }

  const newAttemptCount = currentAttempts + 1;
  setEmailAttemptsCount(newEmail, newAttemptCount);

  if (newAttemptCount >= 3) {
    blockEmailUser(newEmail);
  }

  setEmailAPICallLock(newEmail);

  setLoading(true);

  const update_email_form = new FormData();
  update_email_form.append('email_id', newEmail);


  profileUpdateService
    .emailPhone(update_email_form, "/update_email")
    .then(async (res) => {
      
      if (res.status == 200) {
        if (newAttemptCount < 3) {
          setEmailCooldown(newEmail);
        }
        
        setMobileEmailEditTitle('Verify your Email');
        setShowEmailField(false);
        setShowEmailOTPField(true);
       
        toast.success(res.message, {
          position: "top-right",
          type: "success",
          autoClose: 5000,
        });
      } else {
        
        if (newAttemptCount >= 3) {
          const remainingMinutes = getEmailRemainingTime(newEmail);
          toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
            position: "top-right",
            autoClose: 5000,
          });
        } else {
          toast.error(res.message || "Update failed", {
            position: "top-right",
            autoClose: 5000,
          });
        }
      }
    })
    .catch((err) => {
      
      if (newAttemptCount >= 3) {
        const remainingMinutes = getEmailRemainingTime(newEmail);
        toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
          position: "top-right",
          autoClose: 5000,
        });
      } else {
        toast.error("Something went wrong! Please try again later.", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    })
    .finally(() => {
      removeEmailAPICallLock(newEmail);
      setLoading(false);
    });
};

const sendEmailOTP = (emailArg) => {
  const targetEmail = (emailArg ?? updateEmail ?? '').toString().trim();
  
  
  
  if (!targetEmail) {
    setLoading(false);
    toast.error("Please enter email address", {
      position: "top-right",
      type: "error",
      autoClose: 5000,
    });
    return;
  }


  if (isEmailAPICallInProgress(targetEmail)) {
    toast.warning("Please wait, request is being processed...", {
      position: "top-right",
      autoClose: 2000,
    });
    return;
  }

  if (!isEmailBlocked(targetEmail) && isEmailOnCooldown(targetEmail)) {
    const remainingSeconds = getEmailCooldownRemainingTime(targetEmail);
    toast.warning(`Please wait ${remainingSeconds} seconds before requesting OTP again`, {
      position: "top-right",
      autoClose: 3000,
    });
    return;
  }

  if (isEmailBlocked(targetEmail)) {
    const remainingMinutes = getEmailRemainingTime(targetEmail);
    toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }


  const currentAttempts = getEmailAttemptsCount(targetEmail);

  if (currentAttempts >= 3) {
    blockEmailUser(targetEmail);
    const remainingMinutes = getEmailRemainingTime(targetEmail);
    toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }

  const newAttemptCount = currentAttempts + 1;
  setEmailAttemptsCount(targetEmail, newAttemptCount);

  if (newAttemptCount >= 3) {
    blockEmailUser(targetEmail);
  }

  setEmailAPICallLock(targetEmail);

  setLoading(true);
  const FormData = require("form-data");
  const form = new FormData();
  form.append("email_id", targetEmail);


  commonService
    .CommonService("send_otp_email", form)
    .then(async (res) => {
      
      if (res.status == 200) {
        if (newAttemptCount < 3) {
          setEmailCooldown(targetEmail);
        }
        
        toast.success(res.message, {
          position: "top-right",
          type: "success",
          autoClose: 5000,
        });
      } else {
        
        if (newAttemptCount >= 3) {
          const remainingMinutes = getEmailRemainingTime(targetEmail);
          toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
            position: "top-right",
            autoClose: 5000,
          });
        } else {
          toast.error(res.message || "Failed to send OTP", {
            position: "top-right",
            autoClose: 5000,
          });
        }
      }
    })
    .catch((err) => {
      if (newAttemptCount >= 3) {
        const remainingMinutes = getEmailRemainingTime(targetEmail);
        toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
          position: "top-right",
          autoClose: 5000,
        });
      } else {
        toast.error(err.toString() || "Something went wrong", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    })
    .finally(() => {
      removeEmailAPICallLock(targetEmail);
      setLoading(false);
    });
};

  const emailotpSubmit = (e) =>{
    e.preventDefault();
    setLoading(true); 
    
    let updateEmailOTPValidationError = "no";

    if(emailOTP==""){
      updateEmailOTPValidationError = "yes";
      toast.success("Please enter one time password", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      setLoading(false);
    }
  
    if(updateEmailOTPValidationError=="no")
      {
         // update email
        const update_emailotp_form = new FormData();
        update_emailotp_form.append('email_id', updateEmail);
        update_emailotp_form.append('otp', emailOTP);
        
        profileUpdateService
        .emailPhone(update_emailotp_form,"/verify_email")
        .then(async (res) => {
          if (res.status == 200) {

            setEmail(updateEmail);

            setShowEmailField(false);
            setShowEmailOTPField(false);
           
            toast.success(res.message, {
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
            setIsEmailMobileModelOpen(false);
            window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
            window.location.reload();
          } else {
            toast.success(res.message, {
              position: "top-right",
              type: "error",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
          }
        })
        .catch((err) => {
          toast.success("Something went wrong! please try again later!!", {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        })
        .finally(() => {
          setLoading(false);
          
        });
      }


  }

  const isAPICallInProgress = (mobileNumber) => {
  const lockKey = getLockKey(mobileNumber);
  const lockData = sessionStorage.getItem(lockKey);
  
  if (!lockData) return false;
  
  const lockTime = parseInt(lockData, 10);
  const currentTime = Date.now();
  const fiveSeconds = 5000; 
  
  if (currentTime - lockTime < fiveSeconds) {
    return true;
  } else {
    sessionStorage.removeItem(lockKey);
    return false;
  }
};

const setAPICallLock = (mobileNumber) => {
  const lockKey = getLockKey(mobileNumber);
  sessionStorage.setItem(lockKey, Date.now().toString());
};

const removeAPICallLock = (mobileNumber) => {
  const lockKey = getLockKey(mobileNumber);
  sessionStorage.removeItem(lockKey);
};

const sendMobileOTP = (mobileArg) => {
  const targetMobile = (mobileArg ?? updateMobile ?? '').toString().trim();  
  if (!targetMobile) {
    toast.error("Please enter mobile number", {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }
  if (isAPICallInProgress(targetMobile)) {
    toast.warning("Please wait, request is being processed...", {
      position: "top-right",
      autoClose: 2000,
    });
    return;
  }

  if (!isBlocked(targetMobile) && isOnCooldown(targetMobile)) {
    const remainingSeconds = getCooldownRemainingTime(targetMobile);
    toast.warning(`Please wait ${remainingSeconds} seconds before requesting OTP again`, {
      position: "top-right",
      autoClose: 3000,
    });
    return;
  }

  if (isBlocked(targetMobile)) {
    const remainingMinutes = getRemainingTime(targetMobile);
    toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }

  const currentAttempts = getAttemptsCount(targetMobile);

  if (currentAttempts >= 3) {
    blockUser(targetMobile);
    const remainingMinutes = getRemainingTime(targetMobile);
    toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
      position: "top-right",
      autoClose: 5000,
    });
    return; 
  }

 
  const newAttemptCount = currentAttempts + 1;
  setAttemptsCount(targetMobile, newAttemptCount);

  
  if (newAttemptCount >= 3) {
    blockUser(targetMobile);
  }

  setAPICallLock(targetMobile);

  setLoading(true);
  const FormData = require("form-data");
  const form = new FormData();
  form.append("mobile_number", targetMobile);


  commonService
    .CommonService("send_otp_mobile", form)
    .then(async (res) => {

      
      if (res.status == 200) {
        if (newAttemptCount < 3) {
          setCooldown(targetMobile);
        }
        
        toast.success(res.message, {
          position: "top-right",
          autoClose: 5000,
        });
      } else {
        if (newAttemptCount >= 3) {
          const remainingMinutes = getRemainingTime(targetMobile);
          toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
            position: "top-right",
            autoClose: 5000,
          });
        } else {
          toast.error(res.message || "Failed to send OTP", {
            position: "top-right",
            autoClose: 5000,
          });
        }
      }
    })
    .catch((err) => {
      
      if (newAttemptCount >= 3) {
        const remainingMinutes = getRemainingTime(targetMobile);
        toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
          position: "top-right",
          autoClose: 5000,
        });
      } else {
        toast.error(err.toString() || "Something went wrong", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    })
    .finally(() => {
      removeAPICallLock(targetMobile);
      setLoading(false);
    });
};

const mobileSubmit = (e) => {
  e.preventDefault();
  
  const currentMobile = (phone || '').toString().trim();
  const newMobile = (updateMobile || '').toString().trim().replace(/\D/g, '');
  
  
  if (!newMobile || newMobile.length === 0) {
    toast.error("Please enter a mobile number", {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }
  
  if (newMobile.length !== 10) {
    toast.error("Mobile number must be exactly 10 digits", {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }
  
  if (!/^[6-9]\d{9}$/.test(newMobile)) {
    toast.error("Mobile number must start with 6, 7, 8, or 9", {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }
  
  if (newMobile === currentMobile) {
    toast.error("New mobile is same as current mobile", {
      position: "top-right",
      autoClose: 3000,
    });
    return;
  }

  if (isAPICallInProgress(newMobile)) {
    toast.warning("Please wait, request is being processed...", {
      position: "top-right",
      autoClose: 2000,
    });
    return;
  }

  if (!isBlocked(newMobile) && isOnCooldown(newMobile)) {
    const remainingSeconds = getCooldownRemainingTime(newMobile);
    toast.warning(`Please wait ${remainingSeconds} seconds before requesting OTP again`, {
      position: "top-right",
      autoClose: 3000,
    });
    return;
  }

  if (isBlocked(newMobile)) {
    const remainingMinutes = getRemainingTime(newMobile);
    toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }

  const currentAttempts = getAttemptsCount(newMobile);

  if (currentAttempts >= 3) {
    blockUser(newMobile);
    const remainingMinutes = getRemainingTime(newMobile);
    toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
      position: "top-right",
      autoClose: 5000,
    });
    return; 
  }

  const newAttemptCount = currentAttempts + 1;
  setAttemptsCount(newMobile, newAttemptCount);

  if (newAttemptCount >= 3) {
    blockUser(newMobile);
  }

  setAPICallLock(newMobile);
  setLoading(true);
  const update_mobile_form = new FormData();
  update_mobile_form.append('mobile_number', newMobile);
  

  profileUpdateService
    .emailPhone(update_mobile_form, "/update_mobile")
    .then(async (res) => {
      
      if (res.status == 200) {
        
        if (newAttemptCount < 3) {
          setCooldown(newMobile);
        }
        
        setMobileEmailEditTitle('Verify your Phone Number');
        setShowMobileField(false);
        setShowMobileOTPField(true);
       
        toast.success(res.message, {
          position: "top-right",
          autoClose: 5000,
        });
      } else {
        
        if (newAttemptCount >= 3) {
          const remainingMinutes = getRemainingTime(newMobile);
          toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
            position: "top-right",
            autoClose: 5000,
          });
        } else {
          toast.error(res.message || "Update failed", {
            position: "top-right",
            autoClose: 5000,
          });
        }
      }
    })
    .catch((err) => {
      
      if (newAttemptCount >= 3) {
        const remainingMinutes = getRemainingTime(newMobile);
        toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
          position: "top-right",
          autoClose: 5000,
        });
      } else {
        toast.error("Something went wrong! Please try again later.", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    })
    .finally(() => {
      removeAPICallLock(newMobile);
      setLoading(false);
    });
};


const isOTPButtonDisabled = (mobileArg) => {
  const targetMobile = (mobileArg ?? updateMobile ?? '').toString().trim();
  if (!targetMobile) return false;
  return isBlocked(targetMobile) || isOnCooldown(targetMobile);
};

const isBlocked = (mobileNumber) => {
  const blockKey = getBlockKey(mobileNumber);
  const blockData = localStorage.getItem(blockKey);
  
  if (!blockData) return false;
  
  try {
    const blockInfo = JSON.parse(blockData);
    const blockTime = blockInfo.timestamp;
    const currentTime = Date.now();
    const timeElapsed = currentTime - blockTime;
    const thirtyMinutes = 30 * 60 * 1000;
    
    if (timeElapsed < thirtyMinutes) {
      return true;
    } else {
      localStorage.removeItem(blockKey);
      localStorage.removeItem(getAttemptsKey(mobileNumber));
      sessionStorage.removeItem(getLockKey(mobileNumber));
      return false;
    }
  } catch (error) {
    return false;
  }
};

const getAttemptsCount = (mobileNumber) => {
  const attemptsKey = getAttemptsKey(mobileNumber);
  const attemptsData = localStorage.getItem(attemptsKey);
  const count = attemptsData ? parseInt(attemptsData, 10) : 0;
  return count;
};

// Set attempts count
const setAttemptsCount = (mobileNumber, count) => {
  const attemptsKey = getAttemptsKey(mobileNumber);
  localStorage.setItem(attemptsKey, count.toString());
};


const blockUser = (mobileNumber) => {
  const blockKey = getBlockKey(mobileNumber);
  const blockData = {
    timestamp: Date.now(),
    mobile: mobileNumber
  };
  localStorage.setItem(blockKey, JSON.stringify(blockData));
  const cooldownKey = getCooldownKey(mobileNumber);
  sessionStorage.removeItem(cooldownKey);
};


const getRemainingTime = (mobileNumber) => {
  const blockKey = getBlockKey(mobileNumber);
  const blockData = localStorage.getItem(blockKey);

  if (!blockData) return null;

  try {
    const blockInfo = JSON.parse(blockData);
    const blockTime = blockInfo.timestamp;
    const currentTime = Date.now();
    const timeElapsed = currentTime - blockTime;
    const thirtyMinutes = 30 * 60 * 1000;
    const remainingTime = thirtyMinutes - timeElapsed;

    if (remainingTime > 0) {
      const remainingMinutes = Math.ceil(remainingTime / (60 * 1000));
      return remainingMinutes;
    }
  } catch (error) {
    console.error('[DEBUG] Error calculating remaining time:', error);
  }

  return null;
};

const isOnCooldown = (mobileNumber) => {
  const cooldownKey = getCooldownKey(mobileNumber);
  const cooldownData = sessionStorage.getItem(cooldownKey);
  
  if (!cooldownData) return false;
  
  const cooldownTime = parseInt(cooldownData, 10);
  const currentTime = Date.now();
  const thirtySeconds = 30 * 1000;
  
  if (currentTime - cooldownTime < thirtySeconds) {
    return true;
  } else {
    sessionStorage.removeItem(cooldownKey);
    return false;
  }
};

const setCooldown = (mobileNumber) => {
  const cooldownKey = getCooldownKey(mobileNumber);
  sessionStorage.setItem(cooldownKey, Date.now().toString());
};

const getCooldownRemainingTime = (mobileNumber) => {
  const cooldownKey = getCooldownKey(mobileNumber);
  const cooldownData = sessionStorage.getItem(cooldownKey);
  
  if (!cooldownData) return null;
  
  const cooldownTime = parseInt(cooldownData, 10);
  const currentTime = Date.now();
  const thirtySeconds = 30 * 1000;
  const remainingTime = thirtySeconds - (currentTime - cooldownTime);
  
  if (remainingTime > 0) {
    const remainingSeconds = Math.ceil(remainingTime / 1000);
    return remainingSeconds;
  }
  
  return null;
};

const isEmailOnCooldown = (email) => {
  const cooldownKey = getEmailCooldownKey(email);
  const cooldownData = sessionStorage.getItem(cooldownKey);
  
  if (!cooldownData) return false;
  
  const cooldownTime = parseInt(cooldownData, 10);
  const currentTime = Date.now();
  const thirtySeconds = 30 * 1000;
  
  if (currentTime - cooldownTime < thirtySeconds) {
    return true;
  } else {
    sessionStorage.removeItem(cooldownKey);
    return false;
  }
};

const setEmailCooldown = (email) => {
  const cooldownKey = getEmailCooldownKey(email);
  sessionStorage.setItem(cooldownKey, Date.now().toString());
};

const getEmailCooldownRemainingTime = (email) => {
  const cooldownKey = getEmailCooldownKey(email);
  const cooldownData = sessionStorage.getItem(cooldownKey);
  
  if (!cooldownData) return null;
  
  const cooldownTime = parseInt(cooldownData, 10);
  const currentTime = Date.now();
  const thirtySeconds = 30 * 1000;
  const remainingTime = thirtySeconds - (currentTime - cooldownTime);
  
  if (remainingTime > 0) {
    const remainingSeconds = Math.ceil(remainingTime / 1000);
    return remainingSeconds;
  }
  
  return null;
};











  const mobileotpSubmit = (e) =>{
    e.preventDefault();
    setLoading(true); 
    
    let updateMobileOTPValidationError = "no";

    if(mobileOTP==""){
      updateMobileOTPValidationError = "yes";
      toast.success("Please enter one time password", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      setLoading(false);
    }
  
    if(updateMobileOTPValidationError=="no")
      {
         // update email
        const update_mobileotp_form = new FormData();
        update_mobileotp_form.append('mobile_number', updateMobile);
        update_mobileotp_form.append('otp', mobileOTP);
        
        profileUpdateService
        .emailPhone(update_mobileotp_form,"/verify_mobile")
        .then(async (res) => {
          if (res.status == 200) {
            
            setPhone(updateMobile);

            setShowMobileField(false);
            setShowMobileOTPField(false);
           
            toast.success(res.message, {
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
            window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
            
            setIsEmailMobileModelOpen(false);
            window.location.reload();
          } else {
            toast.success(res.message, {
              position: "top-right",
              type: "error",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
          }
        })
        .catch((err) => {
          toast.success("Something went wrong! please try again later!!", {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        })
        .finally(() => {
          setLoading(false);
        });
      }


  }
   
  //style for model
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "90%",
      maxWidth: "500px",
      height: "auto",
      maxHeight: "90vh",
      background: "transparent",
      border: "none",
      borderRadius: "0",
      padding: "0",
    },
    overlay: { 
      zIndex: 100,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(2px)",
    },
  };

  // Specific styles for rating modal
  const ratingModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "90%",
      maxWidth: "800px",
      height: "auto",
      maxHeight: "90vh",
      background: "transparent",
      border: "none",
      borderRadius: "0",
      padding: "0",
    },
    overlay: { 
      zIndex: 100,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(2px)",
    },
  };

  // Specific styles for delete modals
  const deleteModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "90%",
      maxWidth: "500px",
      height: "auto",
      maxHeight: "90vh",
      background: "transparent",
      border: "none",
      borderRadius: "0",
      padding: "0",
    },
    overlay: { 
      zIndex: 9999, 
      backgroundColor: "rgba(0, 0, 0, 0.4)", 
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(2px)", 
    },
  };
  
   //change password model
   let openChangePasswordmodel = () => {
     setPasswordErrors({
       oldPassword: "",
       newPassword: "",
       confirmPassword: ""
     });
     setIsChangePasswordModelOpen(true);
   };
   let closeChangePasswordmodel = () => {
     setOldPassword("");
     setNewPassword("");
     setConfirmPassword("");
     setPasswordErrors({
       oldPassword: "",
       newPassword: "",
       confirmPassword: ""
     });
     setIsChangePasswordModelOpen(false);
   };

  let openEmailMobileUpdatemodel = (contactType) => {
  setIsEmailMobileModelOpen(true);
  
  setShowMobileField(false);
  setShowEmailField(false);
  setShowEmailOTPField(false);
  setShowMobileOTPField(false);

  if(contactType=="mobile"){
    setMobileEmailEditTitle('Edit Mobile Number');
    setShowMobileField(true);
    setShowEmailField(false);
    setUpdateMobile(phone);
  }
  else if(contactType=="email"){
    setMobileEmailEditTitle('Edit Email');
    setShowMobileField(false);
    setShowEmailField(true);
    setUpdateEmail(email);
  }
};

  let closeEmailMobileUpdatemodel = () => {
    setIsEmailMobileModelOpen(false);
    setShowMobileField(false);
    setShowEmailField(false);
    setShowEmailOTPField(false);
    setShowMobileOTPField(false);
  };
  
  const openWebLink = () => {
    const weLinkUrl = removeHttp(webLink);


    window.open("//"+weLinkUrl, '_blank');
  }

  function removeHttp(url) {
    if (url.startsWith('https://')) {
      const https = 'https://';
      return url.slice(https.length);
    }
  
    if (url.startsWith('http://')) {
      const http = 'http://';
      return url.slice(http.length);
    }
  
    return url;
  }

  const openDeleteModal = () => {
    setDeleteAnimation(true);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = (data) => {
    if(data==="close"){
       setDeleteType("");
    }
    setDeleteAnimation(false);
    setTimeout(() => {
      setIsDeleteModalOpen(false);
    }, 200);
  };

  const handleSetDeleteOption = (type) => {
    setDeleteType(type);
  };

  function handleDeleteOption(){
    closeDeleteModal();
        if(deleteType=='hard'){
    setTimeout(() => {
  
 setIsConfirmationModalOpen(true);
      setDeleteAnimation(true);  
    }, 250);
  }
  else{
    confirmDelete();
  }
  }

  const closeConfirmationModal = () => {
    setDeleteAnimation(false);
    setTimeout(() => {
      setIsConfirmationModalOpen(false);
      setDeleteType("");
    }, 200);
  };

  

  const confirmDelete = () => {
    setLoading(true);
    const payload = {
      delete_type: deleteType === 'soft' ? "soft_delete" : "hard_delete",
      auth_token: localStorage.getItem('auth_token')
    };

    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      formData.append(key, value);
    });

    profileUpdateService
      .deleteProfile(formData) 
      .then(async (res) => {

        if (res.status == 200) {
          if (deleteType === "soft") {


            toast.success(res.message || "Profile soft deleted successfully!", {
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
            StorageHelper.clearAuthDataOnly();
            setTimeout(() => {
              window.location.href = "/";
            }, 2000)

          } else {
            toast.success(res.message || "Profile permanently deleted!", {
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
            StorageHelper.clearAuthDataOnly();
            setTimeout(() => {
              window.location.href = "/";
            }, 2000)
          }
        } else {
          toast.error(res.message || "Delete operation failed!", {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.error("Something went wrong! Please try again later.", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        closeConfirmationModal();
        setLoading(false);
      });

    closeConfirmationModal();
    setLoading(false);
  };
  

  const handleLogout = (e) => {
    e.preventDefault();
    setLogoutAnimation(true);
    setIsLogoutConfirmationModalOpen(true);
  }

  const closeLogoutConfirmationModal = () => {
    setLogoutAnimation(false);
    setTimeout(() => {
      setIsLogoutConfirmationModalOpen(false);
    }, 250);
  }

  const confirmLogout = () => {
    googleLogout();    
    StorageHelper.clearAuthDataOnly();
    setTimeout(() => {
      window.location.href = "/";
    }, 2000)
  }

  const handleKycAddClick = (e) => {
    e.preventDefault();
    
    const isEmailNotVerified = isEmailVerified == "0" || isEmailVerified == 0;
    const isMobileNotVerified = isMobileVerified == "0" || isMobileVerified == 0;
    
    if (isEmailNotVerified && isMobileNotVerified) {
      setKycVerificationMessage("Please verify your email and mobile number before proceeding for KYC.");
      setIsKycVerificationModalOpen(true);
    } else if (isEmailNotVerified) {
      setKycVerificationMessage("Please verify your email before proceeding for KYC.");
      setIsKycVerificationModalOpen(true);
    } else if (isMobileNotVerified) {
      setKycVerificationMessage("Please verify your mobile number before proceeding for KYC.");
      setIsKycVerificationModalOpen(true);
    } else {
      history.push("/kycLanguage");
    }
  };

  const closeKycVerificationModal = () => {
    setIsKycVerificationModalOpen(false);
    setKycVerificationMessage("");
  };

  const fetchUserRating = async () => {
    try {
      setLoading(true);
      let user = JSON.parse(window.localStorage.getItem("UserData"));
      const userId = user.id;

      const form = new FormData();
      form.append("user_id", userId);

      const response = await commonService.CommonService("get_user_rating", form);
      
      if (response.status === "200" || response.status === 200) {
        let ratingDataList = [];
        if (response.data && Array.isArray(response.data)) {
          ratingDataList = response.data;
          setRatingList(ratingDataList);
        } else {
          setRatingList([]);
        }
        
        const calculatedRating = calculateAverageRating(ratingDataList);
        setFetchedRating(calculatedRating);
        
        setIsRatingModalOpen(true);
      } else {
        toast.error(response.message || "Failed to fetch rating", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      }
    } catch (error) {
      console.error("Error fetching user rating:", error);
      toast.error("Something went wrong! Please try again later.", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  const closeRatingModal = () => {
    setIsRatingModalOpen(false);
    setFetchedRating(0);
    setRatingList([]);
  };

  const updateProfileRating = async () => {
    try {
      setLoading(true);
      let user = JSON.parse(window.localStorage.getItem("UserData"));
      const userId = user.id;

      const form = new FormData();
      form.append("user_id", userId);

      const response = await commonService.CommonService("get_user_rating", form);
      
      if (response.status === "200" || response.status === 200) {
        let ratingDataList = [];
        if (response.data && Array.isArray(response.data)) {
          ratingDataList = response.data;
        }
        
        const calculatedRating = calculateAverageRating(ratingDataList);
        setRating(calculatedRating);
        
        toast.success("Rating updated successfully", {
          position: "top-right",
          type: "success",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      } else {
        toast.error(response.message || "Failed to fetch rating", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      }
    } catch (error) {
      console.error("Error fetching user rating:", error);
      toast.error("Something went wrong! Please try again later.", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="profile">
      <style>{`
        .profile-detail.margin-left.my-profile-sec-first ul li.line:has(a:contains("Check Rating")) {
          padding: 0 42px !important;
          margin-right: 1em !important;
          position: relative !important;
        }
        .profile-detail.margin-left.my-profile-sec-first ul li.line:has(a:contains("Check Rating")):after {
          height: 70px !important;
          top: 3px !important;
          left: -9px !important;
        }
        .profile-detail.margin-left.my-profile-sec-first ul li.line:has(a:contains("Check Rating")) a {
          font-size: 16px !important;
          white-space: nowrap;
          font-weight: 600 !important;
        }
        .profile-detail.margin-left.my-profile-sec-first ul li.line.rating-line::after {
         top:10px
        }
        @media (max-width: 768px) {
          .profile-detail.margin-left.my-profile-sec-first ul li.line:has(a:contains("Check Rating")) {
            padding: 0 20px !important;
          }
          .profile-detail.margin-left.my-profile-sec-first ul li.line:has(a:contains("Check Rating")) a {
            font-size: 14px !important;
          }
        }
        @media (max-width: 480px) {
          .profile-detail.margin-left.my-profile-sec-first ul li.line:has(a:contains("Check Rating")) a {
            font-size: 12px !important;
          }
        }
      `}</style>
      <LoadingOverlay>
        <div className="container">
        
          <div className="row">
            <div className="col-md-12">
              <h1 className="title">My Profile</h1>
            </div>
          </div>
          {loginType ==  null && <div className="row">
            <div className="col-md-12">              
              <a className="change-password" style={{cursor:"pointer"}} onClick={openChangePasswordmodel}>
                <i className="bx bx-lock" /> Change Password
              </a>
            </div>
          </div>}

          <div className="profile-detail margin-left my-profile-sec-first">
            <div className="row">
              <div className="col-md-1 padding-0">
                <a
                  href="#!"
                  style={{ 
                    height: 100, 
                    width: 100,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    border: '1px solid #CBCBCB',
                    flexDirection: 'column',
                    overflow: 'hidden'
                  }}
                  className="profile-avatar photo"
                >
                  {image ? (
                    <img 
                      src={image} 
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: '100%', 
                        width: 'auto', 
                        height: 'auto',
                        objectFit: 'contain',
                        margin: '0 !important'
                      }} 
                    />
                  ) : (
                    <img 
                      src="assets/images/profile-avatar.png" 
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: '100%', 
                        width: 'auto', 
                        height: 'auto',
                        objectFit: 'contain',
                        margin: '0 !important'
                      }} 
                    />
                  )}
                  {iskycFilled == "1" ? (
                    <span>
                      Verified by <span>GigFWS</span>
                    </span>
                  ) : null}
                </a>
              </div>
              <div className="col-md-11 padding-0">
                <ul>
                  <li>
                    <a>
                      {name}
                      <span 
                        title={profile.native_location || ''}
                      >
                        {profile.native_location && profile.native_location.length > 30 
                          ? `${profile.native_location.substring(0, 30)}...` 
                          : profile.native_location}
                      </span>

                      {webLink != null ? (

                        <span style={{ display: "table-cell", cursor: "pointer" }} onClick={openWebLink}><span className="weblink-sec">(Web Link)</span></span>
                       
                      ) : null}
                    </a>
                  </li>
                  <li className="line">
                    <a href="#!">
                      {connectCount}<span>Connects</span>
                    </a>
                  </li>
                  <li className="line rating-line">
                    <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); fetchUserRating(); }} className="user-rating-link">
                      <span className="user-rating-badge">
                        <p className="user-rating-star">★</p>
                          {rating ? parseFloat(rating).toFixed(1) : '0.0'}/5
                      </span>
                      <span>Review</span>
                    </a>
                  </li>
                  <li >
                  
                    <Link className="btn btn-default" to="/connect">Connect Now</Link>
                  </li>
                 
                  <li className="edit">
                    <Link className="edit" to="/profileEdit">Edit</Link>
                   
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="profile-detail qualification" style={{padding: "2.5em 2em"}}>
            <div className="row">

              <div className="col-md-1 padding-0">
                <a href="#!" className="profile-avatar"><img src="assets/images/qualification.png" /><span>Contacts</span></a>
              </div>

           <div className="col-md-11 padding-0">
                <ul className="contacts-section">
                  <li className="one">
                    <div className="row">
                      <div className="col-md-2 padding-0">
                        <img src="assets/images/graduation-cap.png" />
                      </div>
                      <div className="col-md-4 padding-0">
                        <p>Phone Number {(isMobileVerified==1) ? <img src="assets/images/verified.png" className="verified" /> : '' }</p>
                        <p><span>{phone}</span></p>
                      </div>
                      <div className="col-md-4 padding-0 text-right">
                        <a href="#!" className="edit mobile-edit-myprofile" onClick={() => openEmailMobileUpdatemodel("mobile")}>{phone ?'Edit Mobile' : 'Add Mobile'}</a>
                        {isMobileVerified == "0" && phone !== "" && (
                          <a
                            className="btn btn-default"
                            style={{marginRight:"15px"}}
                            onClick={() => {
                              openEmailMobileUpdatemodel("mobile");
                              setShowMobileField(false);
                              setShowMobileOTPField(true);
                              setUpdateMobile(phone);
                              try { sendMobileOTP(phone); } catch (_) {}
                            }}
                          >
                            Verify Now
                          </a>
                        )}
                      </div>
                    </div>
                  </li>
                  <li className="line two">
                    <div className="row">
                      <div className="col-md-2 padding-0">
                        <img src="assets/images/graduation-cap.png" />
                      </div>
                      <div className="col-md-4 padding-0">
                        <p>Email Id {(isEmailVerified == 1) ? <img src="assets/images/verified.png" className="verified" /> : '' }</p>
                        <p><span>{email}</span></p>
                      </div>
                     {loginType ==  null && <div className="col-md-4 padding-0 text-right">
                        <a href="#!" className="edit edit-email-sec" onClick={() => openEmailMobileUpdatemodel("email")}>{email ?'Edit Email' : 'Add Email'}</a>
                        {isEmailVerified == "0" && email !== "" &&(loginType !== "null" || loginType !== null) &&(
                          <a
                            className="btn btn-default"
                            style={{right:"-49px", position:"relative"}}
                            onClick={() => {
                              openEmailMobileUpdatemodel("email");
                              setShowEmailField(false);
                              setShowEmailOTPField(true);
                              setUpdateEmail(email);
                              try { sendEmailOTP(email); } catch (_) {}
                            }}
                          >
                            Verify Now
                          </a>
                        )}

                      </div>}
                    </div>
                  </li>
                 
                </ul>
              </div>

          </div>
          </div>

          <div className="profile-detail qualification" style={{padding: "3.5em 2em"}}>
            <div className="row">

              <div className="col-md-1 padding-0">
                <a href="#!" className="profile-avatar"><img src="assets/images/qualification.png" /><span>E-KYC</span></a>
            </div>

            <div className="col-md-11 padding-0" style={{height: "45px"}}>
              {
                iskycFilled == "1" ? (
                <span>
                <br/>
                  Verified <img src="assets/images/verified.png" className="verified" />
                </span>
              ) : (
                <span>
                <br/>
                  <span style={{color: "#dc3545", fontWeight: "500"}}>Pending</span>
                </span>
              )
            }
                <ul>
                <li className="one">
                <br/><br/>
                                    
                </li>
                
                {iskycFilled != "1" && <li className="edit"><a href="#!" className="edit" onClick={handleKycAddClick}>Add</a></li>}
                
              </ul>
              

              <ul>
                
                
                
              </ul>
              
            </div>

          </div>
        </div>

          <div className="profile-detail yorself">
            <div className="row">
              <div className="col-md-1 padding-0">
                <a href="#!" className="profile-avatar">
                  <img src="assets/images/yourself.png" />
                  <span>About Yourself</span>
                </a>
              </div>
              <div className="col-md-11 padding-0">
                <ul>
                  <li>
                    <img src="assets/images/noun_job.png" />
                    <a href="#!">
                    {total ? total : "0"}
                    <span>Years Expert</span>
                    </a>
                  </li>
                  <li className="line">
                    <img src="assets/images/salary.png" />
                    <a href="#!">
                      <img src="assets/images/rupee.png" className="rupee" />
                      {project_rate}
                      <span>Per Hour</span>
                    </a>
                  </li>
                  <li className="line">
                    <img src="assets/images/arrows.png" />
                    <a href="#!">
                    {total_inprogress_project}
                    <span>Projects In Progress</span>
                    </a>
                  </li>
                  <li className="line">
                    <img src="assets/images/start-up.png" />
                    <a href="#!">
                      {projects_completed}
                      <span>Projects Completed</span>
                    </a>
                  </li>
                  <li className="edit">
                    <Link className="edit" to="/experienceEdit">Edit</Link>
                    {/* <a
                      href="#"
                      className="edit"
                      onClick={() => {
                        history.push("/experienceEdit");
                      }}
                    >
                      Edit
                    </a> */}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="profile-detail yorself resume">
            <div className="row">
              <div className="col-md-1 padding-0">
                <a href="#!" className="profile-avatar">
                  <img src="assets/images/resume.png" />
                  <span>My Resume</span>
                </a>
              </div>
              <div className="col-md-11 padding-0">
                <div className="row" style={{padding: "0 15px"}}>
                  <div className="col-md-2">
                    <label style={{fontWeight: "bold", marginBottom: "15px", display: "block"}}>Resume</label>
                    <div className="myresume-file-preview-container" style={{minHeight: "100px"}}>
                      {isLoadingFiles ? (
                        <div className="myresume-file-preview-loading">
                          <div className="myresume-file-preview-spinner"></div>
                          <span className="myresume-file-preview-loading-text">Loading...</span>
                        </div>
                      ) : (
                        resumelist || <span style={{color: "#999"}}>No resume uploaded</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-10">
                    <label style={{fontWeight: "bold", marginBottom: "15px", display: "block"}}>Certificates</label>
                    <div className="myresume-file-preview-container" style={{minHeight: "100px", justifyContent: "flex-start"}}>
                      {isLoadingFiles ? (
                        <div className="myresume-file-preview-loading">
                          <div className="myresume-file-preview-spinner"></div>
                          <span className="myresume-file-preview-loading-text">Loading...</span>
                        </div>
                      ) : (
                        certlist || <span style={{color: "#999"}}>No certificates uploaded</span>
                      )}
                    </div>
                  </div>
                </div>
                <ul style={{marginTop: "20px"}}>
                  <li className="edit">
                    <Link className="edit" to="/myresumeEdit">Edit</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          

          {/* <div className="profile-detail qualification">
            <div className="row">
              <div className="col-md-1 padding-0">
                <a href="#!" className="profile-avatar">
                  <img src="assets/images/qualification.png" />
                  <span>Qualifications</span>
                </a>
              </div>
              <div className="col-md-11 padding-0">
                <ul>
                  <li className="one">
                    <div className="row">
                      <div className="col-md-2 padding-0">
                        <img src="assets/images/graduation-cap.png" />
                      </div>
                      <div className="col-md-10 padding-0">
                        <p>
                          Diploma in Plumbing <span>XXXX University</span>
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2 padding-0">
                        <img src="assets/images/graduation-cap.png" />
                      </div>
                      <div className="col-md-10 padding-0">
                        <p>
                          Diploma in Plumbing <span>XXXX University</span>
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="line two">
                    <div className="row">
                      <div className="col-md-2 padding-0">
                        <img src="assets/images/graduation-cap.png" />
                      </div>
                      <div className="col-md-10 padding-0">
                        <p>
                          Diploma in Plumbing <span>XXXX University</span>
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-2 padding-0">
                        <img src="assets/images/graduation-cap.png" />
                      </div>
                      <div className="col-md-10 padding-0">
                        <p>
                          Diploma in Plumbing <span>XXXX University</span>
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="edit three">
                    <Link className="edit" to="/referenceEdit">Edit</Link>
                  
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
          <div className="profile-detail qualification referance personal-qualification">
            <div className="row">
              <div className="col-md-1 padding-0">
                <a href="#!" className="profile-avatar">
                  <img src="assets/images/referance.png" />
                  <span>References</span>
                </a>
              </div>
              <div className="col-md-11 padding-0">
                <ul>
                  <li className="one">
                    <p className="stripe">Professional</p>
                    <div className="row">
                      <div className="col-md-2 padding-0">
                        <img src="assets/images/graduation-cap.png" />
                      </div>
                      <div className="col-md-10 padding-0">
                        {professionalName.map((item, index) => (
                          <p>
                            {item}
                            <span> {professionalprofession[index]}</span>
                          </p>
                        ))}
                      </div>
                    </div>
                  </li>
                  <li className="line two">
                    <p className="stripe">Personal</p>
                    <div className="row">
                      <div className="col-md-2 padding-0">
                        <img src="assets/images/graduation-cap.png" alt="Personal Reference" />
                      </div>
                      <div className="col-md-10 padding-0">
                        {personalname.map((item, index) => (
                          <p key={index}>
                            {item}
                            <span> {personalprofession[index]}</span>
                          </p>
                        ))}
                      </div>
                    </div>
                  </li>
                  <li className="edit">
                    <Link className="edit" to="/referenceEdit">Edit</Link>
                    {/* <a
                      href="#!"
                      className="edit"
                      onClick={() => {
                        history.push("/referenceEdit");
                      }}
                    >
                      Edit
                    </a> */}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginTop: "30px", marginBottom: "20px" }}>
            <div style={{display :"flex",justifyContent: "center"}}>
              <a className="delete-profile-btn" onClick={openDeleteModal}>
                <i className="bx bx-trash" /> Delete Profile
              </a>
            </div>
          </div>

          <div className="row" style={{ marginTop: "30px", marginBottom: "20px" }}>
            <div style={{display :"flex",justifyContent: "center"}}>
              <a className="logout-profile-btn" onClick={handleLogout}>
              <img src="/assets/images/LogOutIcon.svg"/> Logout
              </a>
            </div>
          </div>


        <Modal
          isOpen={isChangePasswordModelOpen}
          onRequestClose={closeChangePasswordmodel}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup reset-password-sec" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Change Password</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeChangePasswordmodel}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="passowrd-reset-omdal modal-body">
                <div className="terms-condition not-scrollable">
                  <div className="col-md-12">
                    <div className="form-group cp-old-password">
                      <input
                        type="password"
                        className="form-control"
                        required="required"
                        placeholder="*Old Password"
                        value={oldPassword}
                        onChange={(e) => {
                          const value = e.target.value;
                          setOldPassword(value);
                          setPasswordErrors(prev => ({
                            ...prev,
                            oldPassword: value.trim() === "" ? "Old Password is required" : ""
                          }));
                        }}
                        ref = {oldPassword1}
                      />
                      <ReactPasswordToggleIcon 
                            inputRef={oldPassword1} 
                            showIcon={hideIcon}
                            hideIcon={showIcon}
                          /> 
                      <label className="error">
                        {passwordErrors.oldPassword ? passwordErrors.oldPassword : ""}
                      </label>
                    </div>

                    <div className="form-group cp-new-password">
                      <input
                        type="password"
                        className="form-control"
                        required="required"
                        placeholder="*New Password (8 chars, 1 uppercase, 1 number, 1 special)"
                        value={newPassword}
                        onChange={(e) => {
                          const value = e.target.value;
                          setNewPassword(value);
                          let error = "";
                          if(value.trim() === ""){
                            error = "New Password is required";
                          } else {
                            const hasMinLength = value.length >= 8;
                            const hasUpperCase = /[A-Z]/.test(value);
                            const hasNumber = /[0-9]/.test(value);
                            const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value);
                            
                            if(!hasMinLength){
                              error = 'Password must be at least 8 characters';
                            } else if(!hasUpperCase){
                              error = 'Password must contain at least 1 uppercase letter';
                            } else if(!hasNumber){
                              error = 'Password must contain at least 1 number';
                            } else if(!hasSpecialChar){
                              error = 'Password must contain at least 1 special character';
                            }
                          }
                          setPasswordErrors(prev => ({
                            ...prev,
                            newPassword: error
                          }));
                        }}
                        ref = {newPassword1}
                      />
                      <ReactPasswordToggleIcon 
                            inputRef={newPassword1} 
                            showIcon={hideIcon}
                            hideIcon={showIcon}
                          /> 
                      <label className="error">
                        {passwordErrors.newPassword ? passwordErrors.newPassword : ""}
                      </label>
                    </div>

                    <div className="form-group cp-confirm-new-password">
                      <input
                        type="password"
                        className="form-control"
                        required="required"
                        placeholder="*Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => {
                          const value = e.target.value;
                          setConfirmPassword(value);
                          let error = "";
                          if(value.trim() === ""){
                            error = "Confirm Password is required";
                          } else if(value !== newPassword){
                            error = 'Passwords do not match';
                          }
                          setPasswordErrors(prev => ({
                            ...prev,
                            confirmPassword: error
                          }));
                        }}
                        ref = {confirmNewPassword}
                      />
                      <ReactPasswordToggleIcon 
                            inputRef={confirmNewPassword} 
                            showIcon={hideIcon}
                            hideIcon={showIcon}
                          /> 
                      <label className="error">
                        {passwordErrors.confirmPassword ? passwordErrors.confirmPassword : ""}
                      </label>
                    </div>

                    <button className="btn btn-default" onClick={changePassword}>Update</button>
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </Modal>
        
        <Modal
          isOpen={isEmailMobileModelOpen}
          onRequestClose={closeEmailMobileUpdatemodel}
          style={customStyles}
          contentLabel="Update Contact"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{mobileEmailEditTitle} </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeEmailMobileUpdatemodel}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="my-profile-edit-email terms-condition">
                  <div className="col-md-12">                    

                    {showEmailField==true &&
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control"
                          required="required"
                          placeholder="*Email Address"
                          
                          onChange={(e) => {
                            setUpdateEmail(e.target.value);
                          }}
                        />
                        <button className="btn btn-default" onClick={emailSubmit}>Update</button>
                      </div>                        
                    }

                      {showEmailOTPField == true &&
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            required="required"
                            placeholder="Enter one time password"
                            value={emailOTP}
                            onChange={(e) => {
                              setEmailOTP(e.target.value);
                            }}
                          />
                          <p style={{ textAlign: "right", marginBottom: "5px" }}>
                            <span
                              style={{
                                cursor: isEmailOTPButtonDisabled(updateEmail) ? 'not-allowed' : 'pointer',
                                color: isEmailOTPButtonDisabled(updateEmail) ? '#999' : '#007bff',
                                opacity: isEmailOTPButtonDisabled(updateEmail) ? 0.6 : 1
                              }}
                              onClick={() => {
                                if (!loading && !isEmailOTPButtonDisabled(updateEmail)) {
                                  sendEmailOTP(updateEmail);
                                }
                              }}
                            >
                              Resend OTP
                            </span>
                          </p>
                          {(isEmailOTPButtonDisabled(updateEmail) || (remainingEmailMinutes && remainingEmailMinutes > 0) || (remainingEmailCooldownSeconds && remainingEmailCooldownSeconds > 0)) && (
                            <div style={{
                              textAlign: "center",
                              padding: '8px',
                              backgroundColor: '#fff3cd',
                              border: '1px solid #ffc107',
                              borderRadius: '4px',
                              marginBottom: '15px'
                            }}>
                              <p style={{
                                color: '#856404',
                                fontSize: '13px',
                                margin: 0,
                                fontWeight: '500'
                              }}>
                                {remainingEmailCooldownSeconds && remainingEmailCooldownSeconds > 0 ? (
                                  <>⏰ Please wait {remainingEmailCooldownSeconds} {remainingEmailCooldownSeconds === 1 ? 'second' : 'seconds'} before resending OTP</>
                                ) : (
                                  <>⏰ Please wait for {remainingEmailMinutes || getEmailRemainingTime(updateEmail)} {remainingEmailMinutes === 1 ? 'minute' : 'minutes'} before resending OTP</>
                                )}
                              </p>
                            </div>
                          )}
                          <button className="btn btn-default" onClick={emailotpSubmit}>Verify</button>
                        </div>
                      }
                      {showMobileField == true &&
                        <div className="form-group">
                          <input
                            type="tel"
                            className="form-control"
                            required="required"
                            placeholder="*Mobile Number (10 digits)"
                            maxLength={10}
                            inputMode="numeric"
                            value={updateMobile}
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                              setUpdateMobile(value);
                            }}
                          />
                          <label className="error" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
                            {updateMobile && updateMobile.length > 0 && updateMobile.length !== 10
                              ? 'Mobile number must be exactly 10 digits'
                              : updateMobile && updateMobile.length === 10 && !/^[6-9]/.test(updateMobile)
                                ? 'Mobile number must start with 6, 7, 8, or 9'
                                : ''}
                          </label>
                          {isOTPButtonDisabled(updateMobile) && remainingMinutes && (
                            <p style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
                              Too many attempts. Please try again after {remainingMinutes} minutes.
                            </p>
                          )}
                          <button
                            className="btn btn-default"
                            onClick={mobileSubmit}
                            disabled={loading || isOTPButtonDisabled(updateMobile)}
                            style={{
                              opacity: (loading || isOTPButtonDisabled(updateMobile)) ? 0.6 : 1,
                              cursor: (loading || isOTPButtonDisabled(updateMobile)) ? 'not-allowed' : 'pointer'
                            }}
                          >
                            {loading ? 'Updating...' :
                              isOTPButtonDisabled(updateMobile) && remainingMinutes ?
                                `Try after ${remainingMinutes} min` :
                                'Update'}
                          </button>
                        </div>
                      }
                    
                      {showMobileOTPField == true &&
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            required="required"
                            placeholder="Enter one time password"
                            value={mobileOTP}
                            onChange={(e) => {
                              setMobileOTP(e.target.value);
                            }}
                          />
                          <p style={{ textAlign: "right", marginBottom: "5px" }}>
                            <span
                              style={{
                                cursor:  isOTPButtonDisabled(updateMobile) ? 'not-allowed' : 'pointer',
                                color:  isOTPButtonDisabled(updateMobile) ? '#999' : '#007bff',
                                opacity:  isOTPButtonDisabled(updateMobile) ? 0.6 : 1
                              }}
                              onClick={() => {
                                if (!loading && !isOTPButtonDisabled(updateMobile)) {
                                  sendMobileOTP(updateMobile);
                                }
                              }}
                            >
                              Resend OTP
                            </span>
                          </p>
                          {(isOTPButtonDisabled(updateMobile) || (remainingMinutes && remainingMinutes > 0) || (remainingCooldownSeconds && remainingCooldownSeconds > 0)) && (
                            <div style={{
                              textAlign: "center",
                              padding: '8px',
                              backgroundColor: '#fff3cd',
                              border: '1px solid #ffc107',
                              borderRadius: '4px',
                              marginBottom: '15px'
                            }}>
                              <p style={{
                                color: '#856404',
                                fontSize: '13px',
                                margin: 0,
                                fontWeight: '500'
                              }}>
                                {remainingCooldownSeconds && remainingCooldownSeconds > 0 ? (
                                  <>⏰ Please wait {remainingCooldownSeconds} {remainingCooldownSeconds === 1 ? 'second' : 'seconds'} before resending OTP</>
                                ) : (
                                  <>⏰ Please wait for {remainingMinutes} {remainingMinutes === 1 ? 'minute' : 'minutes'} before resending OTP</>
                                )}
                              </p>
                            </div>
                          )}
                          <button className="btn btn-default" onClick={mobileotpSubmit}>Verify</button>
                        </div>
                      }
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          style={deleteModalStyles}
          contentLabel="Delete Profile"
          scrollable={true}
        >
          <div className={`modal-dialog loginpopup delete-profile-modal ${deleteAnimation ? 'fade-in' : 'fade-out'}`} role="document">
            <div className="modal-content">
              <div className="delete-profile-modal-header">
                <div className="delete-profile-modal-header-modal-title">Delete Profile</div>
                <button
                  type="button"
                  className="delete-profile-modal-header-delete-button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={()=>closeDeleteModal("close")}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="delete-profile-modal-body">
                <div className="delete-options">
                  <div className={deleteType==='soft' ? "delete-option-active" : "delete-option"} onClick={() => handleSetDeleteOption("soft")}>
                
                    <div className="option-content">
                      <div className="delete-profile-heading">Soft Delete (Deactivate Account)</div>
                      <p className="delete-profile-content">Your profile will be hidden. You can reactivate it anytime within 30 days.</p>
                    </div>
                  
                  </div>
                  
                  <div className={deleteType==='hard' ? "delete-option-active" : "delete-option"} onClick={() => handleSetDeleteOption("hard")}>
                  
                    <div className="option-content">
                      <div className="delete-profile-heading-delete-permanent">Hard Delete (Permanent Delete)</div>
                      <p className="delete-profile-content">Your profile and all data will be permanently removed. This action cannot be undone.</p>
                    </div>
                    
                  </div>
                </div>

                <button disabled={deleteType===""}  onClick={()=>handleDeleteOption()} className={deleteType=="" ?"delete-modal-continue-button-disabled" :"delete-modal-continue-button"}>
                  Continue
                </button>
                <div className="delete-warning-message">
                  Choose carefully, as permanent deletion cannot be undone.
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isConfirmationModalOpen}
          onRequestClose={closeConfirmationModal}
          style={deleteModalStyles}
          contentLabel="Confirm Delete"
          scrollable={true}
        >
          <div className={`modal-dialog  confirmation-modal ${deleteAnimation ? 'fade-in' : 'fade-out'}`} role="document">
            <div className="modal-content">
              <div className="warning-icon-confirmation">
                    <img className="warning-icon-for-delete" src={WarningIcon}/>
              </div>
              <div className="pop-up-delete-heading-confirmation">
                    Delete account
              </div>
              <div className="pop-up-delete-message-confirmation">
                This action is permanent and cannot be undone.
              </div>
              <div className="button-section-delete-and-cancel-delete">
                <button            onClick={closeConfirmationModal} className="cancel-button">Cancel</button>
                <button onClick={()=> confirmDelete()} className="confirm-button">Confirm</button>

              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isLogoutConfirmationModalOpen}
          onRequestClose={closeLogoutConfirmationModal}
          style={deleteModalStyles}
          contentLabel="Confirm Logout"
          scrollable={true}
        >
          <div className={`modal-dialog  confirmation-modal ${logoutAnimation ? 'fade-in' : 'fade-out'}`} role="document">
            <div className="modal-content">
              <div className="warning-icon-confirmation">
                    <img className="warning-icon-for-delete" src={WarningIcon}/>
              </div>
              <div className="pop-up-delete-heading-confirmation">
                    Logout
              </div>
              <div className="pop-up-delete-message-confirmation">
                Are you sure you want to logout? 
              </div>
              <div className="button-section-delete-and-cancel-delete">
                <button onClick={closeLogoutConfirmationModal} className="cancel-button">Cancel</button>
                <button onClick={confirmLogout} className="confirm-button">Logout</button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isKycVerificationModalOpen}
          onRequestClose={closeKycVerificationModal}
          style={deleteModalStyles}
          contentLabel="KYC Verification Required"
          scrollable={true}
        >
          <div className={`modal-dialog confirmation-modal fade-in`} role="document">
            <div className="modal-content">
              <div className="warning-icon-confirmation">
                <img className="warning-icon-for-delete" src={WarningIcon}/>
              </div>
              <div className="pop-up-delete-heading-confirmation">
                Verification Required
              </div>
              <div className="pop-up-delete-message-confirmation">
                {kycVerificationMessage}
              </div>
              <div className="button-section-delete-and-cancel-delete">
                <button onClick={closeKycVerificationModal} className="confirm-button">OK</button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isRatingModalOpen}
          onRequestClose={closeRatingModal}
          style={ratingModalStyles}
          contentLabel="User Rating"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup" role="document">
            <div className="modal-content" style={{borderRadius: '12px'}}>
              <div className="modal-header" style={{borderRadius: '12px 12px 0 0'}}>
                <h5 className="modal-title">Your Rating</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeRatingModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body" style={{ padding: '30px', maxHeight: '70vh', overflowY: 'auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '30px', paddingBottom: '20px', borderBottom: '2px solid #e5e7eb' }}>
                  <p style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                    Based on {ratingList.length} {ratingList.length === 1 ? 'review' : 'reviews'}
                  </p>
                </div>

                {ratingList.length > 0 ? (
                  <div style={{ marginTop: '20px' }}>
                    {ratingList.map((ratingItem, index) => {
                      const jobId = ratingItem.job_details?.job_id || ratingItem.job_id;
                      const hasJobId = jobId && jobId !== '' && jobId !== null && jobId !== 'null';
                      const userRating = parseFloat(ratingItem.user_rating || 0);
                      const comment = ratingItem.user_comment || 'No comment provided';
                      const receivedDate = ratingItem.created_at 
                        ? moment(ratingItem.created_at).format('MMM DD, YYYY')
                        : 'N/A';
                      
                      return (
                        <div 
                          key={ratingItem.id || index}
                          style={{
                            background: 'white',
                            border: '1px solid #e5e7eb',
                            borderRadius: '8px',
                            padding: '20px',
                            marginBottom: '16px'
                          }}
                        >
                          {hasJobId && (
                            <div style={{ marginBottom: '12px' }}>
                              <p style={{ 
                                fontSize: '16px', 
                                fontWeight: '600', 
                                margin: 0 
                              }}>
                                <span style={{ color: '#f57e1f' }}>{jobId}</span>
                              </p>
                            </div>
                          )}
                          
                          <div style={{ marginBottom: '12px' }}>
                            <Rating
                              initialValue={userRating}
                              ratingValue={userRating}
                              readonly={true}
                              allowFraction={true}
                              size={20}
                              fillColor="#f57e1f"
                              emptyColor="#e0e0e0"
                            />
                            <span style={{ 
                              marginLeft: '10px', 
                              fontSize: '14px', 
                              fontWeight: '500', 
                              color: '#4b5563' 
                            }}>
                              {userRating.toFixed(1)}
                            </span>
                          </div>
                          
                          <div style={{ marginBottom: '12px' }}>
                            <p style={{ 
                              color: '#111827', 
                              fontSize: '14px', 
                              margin: 0,
                              lineHeight: '1.5'
                            }}>
                              <span style={{ color: '#6b7280', fontWeight: '500', marginRight: '6px' }}>Comments:</span>
                              <span style={{ color: '#111827' }}>{comment}</span>
                            </p>
                          </div>
                          
                          <div>
                            <p style={{ 
                              color: '#6b7280', 
                              fontSize: '12px', 
                              margin: 0 
                            }}>
                              Received on {receivedDate}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                    <p>No reviews found</p>
                  </div>
                )}

                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                  <button 
                    className="btn btn-default" 
                    onClick={closeRatingModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        </div>
        

        <Loader loading={loading} />
      </LoadingOverlay>
    </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyProfileView);
